import React, { useState } from "react";
import Select from "react-select";

function ImportMappingModal({ columns, modelFields, onConfirm, onCancel, onTest, errors }) {
    const [mapping, setMapping] = useState({});

    const fieldOptions = modelFields.map(f => ({
        value: f.name || f,
        label: f.string ? `${f.string} (${f.name})` : f
    }));

    const handleChange = (col, selectedOption) => {
        setMapping({ ...mapping, [col]: selectedOption ? selectedOption.value : "" });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl p-8 min-w-[600px] flex flex-col gap-6 border border-gray-200">
                {errors && (
                    <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-2 rounded mb-2 max-h-40 overflow-y-auto text-sm">
                        {Array.isArray(errors) ? (
                            <ul className="list-disc pl-5">
                                {errors.map((err, idx) => (
                                    <li key={idx}>
                                        {err.row ? `Ligne ${err.row}: ` : ""}
                                        {err.errors
                                            ? Object.entries(err.errors).map(([field, msg]) =>
                                                <span key={field}><b>{field}</b>: {msg} </span>
                                            )
                                            : err}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <span>{errors}</span>
                        )}
                    </div>
                )}
                <button
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded shadow"
                        type="button"
                    >
                        Télécharger modele d'import
                </button>
                <div className="flex items-center justify-between mb-2">                    
                    <h2 className="text-xl font-bold text-gray-800">Mapper les colonnes</h2>                    
                    <button
                        className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                        onClick={onCancel}
                        title="Fermer"
                    >
                        ×
                    </button>
                </div>
                <div className="flex flex-col gap-4 max-h-[50vh] overflow-y-auto">
                    <div className="flex gap-3 items-center pb-2 border-b border-gray-200">
                        <span className="w-40 font-semibold text-gray-500 uppercase text-xs tracking-wider">
                            Colonne du fichier
                        </span>
                        <span className="flex-1 font-semibold text-gray-500 uppercase text-xs tracking-wider">
                            Champ du modèle
                        </span>
                    </div>
                    {columns.map(col => (
                        <div key={col} className="flex gap-3 items-center">
                            <span className="w-40 font-medium text-gray-700">{col}</span>
                            <div className="flex-1">
                                <Select
                                    options={fieldOptions}
                                    value={fieldOptions.find(opt => opt.value === mapping[col]) || null}
                                    onChange={option => handleChange(col, option)}
                                    isClearable
                                    placeholder="-- Champ --"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex gap-3 mt-6 justify-between">
                    <button
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded shadow"
                        onClick={onCancel}
                        type="button"
                    >
                        Annuler
                    </button>

                    <div className="flex gap-3">
                        <button
                            className="bg-[--color-orange] text-white px-4 py-2 rounded shadow"
                            onClick={() => onTest && onTest(mapping)}
                            type="button"
                        >
                            Tester
                        </button>
                        <button
                            className="bg-[--color-primary]  text-white px-4 py-2 rounded shadow"
                            onClick={() => onConfirm(mapping)}
                            type="button"
                        >
                            Importer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImportMappingModal;